<template lang="pug">
  SspLayout(area="core")
    template(slot="actions")
      button.btn.btn-danger(@click="detachSectionMetadataSchema" v-if="section && section.metadata") Detach metadata schema

    .alert.alert-warning(v-if="noMetadataInfo")
      span Metadata schema not selected. Please go to <router-link :to="{name: 'editSection'}">Edit Section</router-link> to select metadata schema.
    Loading(v-if="loading")
    .editor(v-else)
      MetadataEditor(:schema="schema" :metadata="metadata" :disabled="readOnly || saving" @update:data="updateMetadata")
      .text-right.pt20
        SspActionButton(@onClick="save()" :spinning="saving" :disabled="readOnly || !isValid") Save
        a.ml10.btn.btn-default(type="button" @click="$router.go(-1)") Cancel
</template>

<script>
import miniToastr from 'mini-toastr'
import MetadataEditor from '@/components/metadataeditor/MetadataEditor'
import Core from '@/service/apis/Core'
import AuthService from '@/service/AuthService'
import { isEmpty } from '@/utils/lodash'

export default {
  data: () => ({
    metadata: {},
    schema: {},
    saving: false,
    section: null,
    loading: false,
    isValid: true,
    readOnly: !AuthService.hasRole('ROLE_METADATA_MANAGER'),
    noMetadataInfo: false
  }),
  created() {
    this.loadSection(this.sectionId)
  },
  methods: {
    updateMetadata(metadata, isValid) {
      this.metadata = { ...this.metadata, ...metadata }
      this.isValid = isValid
    },
    loadSection(sectionId) {
      this.loading = true
      Core.getSection(sectionId)
        .then((resp) => {
          const section = resp.data
          this.section = resp.data
          if (!section.metadata) {
            this.readOnly = true
            this.noMetadataInfo = true
            return
          }
          this.metadata = section.metadata.data
          if (section.metadata.schema) {
            const schemaId = section.metadata.schema.id
            return Core.getSchemaById(schemaId)
              .then((r) => {
                this.schema = r.data
              })
          }
        })
        .catch((e) => { this.$emit('error', e) })
        .then(() => {
          this.loading = null
        })
    },
    save() {
      this.saving = true
      const { metadata } = this
      Core.saveSectionMetadata(this.orderId, this.sectionId, metadata)
        .then(() => {
          miniToastr.success('Section metadata updated successfully')
          this.$router.push({ name: 'section' })
        })
        .catch((e) => { this.$emit('error', e) })
        .then(() => {
          this.saving = false
        })
    },
    detachSectionMetadataSchema() {
      const req = {
        enabled: this.section.enabled,
        endIndex: this.section.last.codeIndex,
        id: this.sectionId,
        orderId: this.section.orderId,
        startIndex: this.section.first.codeIndex + 1,
      }

      if (this.section.metadata && !isEmpty(this.section.metadata.data)) {
        Core.deleteOrderSectionMetadata(this.orderId, this.sectionId)
          .then(() => {
            Core.updateSection(this.sectionId, req)
              .then(() => {
                this.$router.push({ name: 'section', params: { id: this.sectionId } })
                miniToastr.success('Metadataschema detached')
              })
          })
      }
    }
  },
  computed: {
    orderId() {
      return parseInt(this.$route.params.orderId, 10)
    },
    sectionId() {
      return parseInt(this.$route.params.sectionId, 10)
    }
  },
  components: {
    MetadataEditor
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/core/order/section/SectionMetadata.vue